<template>
  <div>
    <b>{{ notification.cause.entityName }}</b>
    {{ $t(this.messageBody) }}
    <i>{{ notification.details.documentTitle }}</i>
  </div>
</template>
<script>
export default {
  name: 'AnalysisNotificationCardContent',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    messageBody() {
      if (this.notification.details.type === 'assigned') {
        return 'views.notifications.missionAssigned.body';
      }
      if (this.notification.details.type === 'accomplished') {
        return 'views.notifications.missionAccomplished.body';
      }
      return 'views.notifications.missionAssigned.body';
    },
  },
};
</script>
<style scoped>
</style>
